import React from 'react'

export default function HelpAside () {
  return (
    <React.Fragment>
      <div className='border-color-ui-3 bg-white border px-3 py-4'>
        <h3>Central de atendimento</h3>
      </div>
      <div className='border-color-ui-3 col-12 bg-white border px-3 py-2'>
        <p className='mb-2'>Tem dúvidas sobre <strong>entrega, extravio, 2ª via, ativar ou desbloquear</strong> do seu cartão Pré-Pago Like+, ligue:</p>
        <h3 className='mb-1'>4020-0221</h3>
        <p>Horário de atendimento: de segunda a sexta-feira, das 9h às 18h, exceto feriados.</p>
      </div>
      <div className='border-color-ui-3 col-12 bg-white border px-3 py-2'>
        <p className='mb-2'>Ou entre em contato por e-mail:</p>
        <h3 className='mb-1'><a href='mailto:atendimento@acgsa.com.br'>atendimento@acgsa.com.br</a></h3>
      </div>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/features/LikePlusCustom/Tabs/Help/HelpAside.js